module.exports = __webpack_public_path__ + "static/dog-56036d1d1573573f387e8957a05d17d4.jpg";